import { styled } from 'styled-components'

export * from './heading'
export * from './link'
export * from './list'
export * from './paragraphs'

export * as headings from './heading'
export * as lists from './list'
export * as paragraphs from './paragraphs'

export const Strong = styled.strong`
	font-weight: 700;
`

export const U = styled.u`
	text-decoration: underline;
`
export const Code = styled.code`
	background-color: ${({ theme }) =>
		theme.darkMode ? theme.colors.extended.grey[600] : '#eee'};
	color: inherit;
	padding: 0.25rem;
	border-radius: 0.25rem;
`
